import { formatNumber } from '@edge/spark/utils'
import type { SearchVehicle } from '../types'

export const odometer = ({ odometer: _odometer }: SearchVehicle): string => formatNumber(_odometer) || '—'
